import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebf746c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-0 ma-0" }
const _hoisted_2 = { class: "figuresList" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  ref: "chartCanvas",
  class: "chartCanvas",
  preserveAspectRatio: "xMinYMin meet"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sourcesText" }, "Source: Macrobond", -1))
const _hoisted_6 = {
  key: 0,
  class: "legend"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-item" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "12",
    height: "2"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "2",
      fill: "#DC0028"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Imports")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-item" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "12",
    height: "2"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "2",
      fill: "#333333"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Exports")
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "tooltip",
  style: {"position":"absolute","opacity":"0","background-color":"white","border":"1px solid black","padding":"5px","pointer-events":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_name_bar = _resolveComponent("country-name-bar")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.country && _ctx.country.gdp.length > 0)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "pl-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "countryNameBar__holder pb-8 pl-3 ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_country_name_bar, {
                        countryName: _ctx.country.country_name
                      }, null, 8, ["countryName"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_tabs, {
                      modelValue: _ctx.activeFigure,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeFigure) = $event)),
                      "slider-color": "#DC0028",
                      class: "keyFiguresTabsMobile",
                      "show-arrows": false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyFigures, (figure, index) => {
                          return (_openBlock(), _createBlock(_component_v_tab, {
                            key: figure.title,
                            onClick: ($event: any) => (_ctx.setActiveFigure(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(figure.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyFigures, (figure, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: figure.title,
                        class: _normalizeClass([['figureTitle', { active: index === _ctx.activeFigure }], "mb-6"]),
                        onClick: ($event: any) => (_ctx.setActiveFigure(index))
                      }, _toDisplayString(figure.title), 11, _hoisted_3))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mobileText pa-0 ma-0",
                cols: "12"
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "pa-0 ma-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "chartContainer pa-0 ma-0" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("svg", _hoisted_4, null, 512))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "chartInfoRow" }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      (_ctx.keyFigures[_ctx.activeFigure].key === 'importData')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_10
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}